import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { comics } from '@/mocks/comics';

export default function HotRanking() {
  const { t } = useTranslation();
  const ranked = [...comics].sort((a, b) => b.views - a.views).slice(0, 8);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
            <i className="ri-fire-line text-accent-500 mr-2"></i>
            {t('home.hot_title')}
          </h2>
          <p className="text-sm text-foreground-600">{t('home.hot_subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {ranked.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="flex items-center gap-4 p-3 rounded-lg bg-background-50 hover:bg-background-100 transition-colors cursor-pointer no-underline group"
            >
              <div className="relative flex-shrink-0">
                <span className={`absolute -top-1 -left-1 w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold text-background-50 z-10 ${
                  index < 3 ? 'bg-accent-500' : 'bg-foreground-400'
                }`}>
                  {index + 1}
                </span>
                <div className="w-16 h-20 rounded-md overflow-hidden">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    title={`${comic.title} - 热门排行`}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors truncate">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
                <div className="flex items-center gap-3 mt-1">
                  <span className="text-[10px] text-accent-500 flex items-center gap-0.5">
                    <i className="ri-star-fill text-[10px]"></i>
                    {comic.rating}
                  </span>
                  <span className="text-[10px] text-foreground-400">
                    {(comic.views / 10000).toFixed(0)}万{t('home.views')}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}